import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Spinner } from "flowbite-react";
import useSize from "../../../../Utils/useSize/useSize";
import Loading from "../../../../Utils/Loading/Loading";
import Backend from "../../../../Backend/Backend";
import TopHeader from "./TopHeader";

const backend = await new Backend().init();

export default function GenerateBill() {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  const [id] = useState(localStorage.getItem("id") || "");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  // Today's date for max limit
  const today = new Date().toISOString().split("T")[0];

  const createPdf = async () => {
    if (!id) return toast.error("User ID not found!");
    if (!start) return toast.error("Please select start date!");
    if (!end) return toast.error("Please select end date!");

    try {
      setLoading(true);
      setUrl("");

      const data = { id, start, end };
      const response = await backend.createdpdf(data);

      if (response.error === "False") {
        toast.success("PDF generated successfully!");
        setTimeout(() => {
          setUrl(response.url);
          setLoading(false);
        }, 1500);
      } else {
        setLoading(false);
        toast.error(response.message);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="flex flex-col w-full bg-[var(--background)] text-[var(--text)]">
      <TopHeader />

      <div className="w-full max-w-6xl p-4 md:p-6">
        <div className="bg-[var(--background)] border-2 border-[var(--hover)] rounded-2xl shadow-md p-6 transition-all">
          {/* Filter Fields */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 items-end">
            {/* Start Date */}
            <div className="flex flex-col">
              <label
                htmlFor="start"
                className="text-xs font-medium mb-1 text-[var(--text)] tracking-wide"
              >
                Start Date
              </label>
              <input
                type="date"
                id="start"
                max={today} // Prevent future dates
                className="rounded-md border-2 border-[var(--hover)] bg-[var(--background)] px-2.5 py-1.5 text-sm text-[var(--text)] focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition-all"
                value={start}
                onChange={(e) => {
                  const val = e.target.value;

                  if (val > today) {
                    toast.error("Start date cannot be in the future!");
                    return;
                  }

                  if (end && val > end) {
                    toast.error("Start date cannot be greater than end date!");
                    return;
                  }

                  setStart(val);
                }}
              />
            </div>

            {/* End Date */}
            <div className="flex flex-col">
              <label
                htmlFor="end"
                className="text-xs font-medium mb-1 text-[var(--text)] tracking-wide"
              >
                End Date
              </label>
              <input
                type="date"
                id="end"
                max={today} // Prevent future dates
                className="rounded-md border-2 border-[var(--hover)] bg-[var(--background)] px-2.5 py-1.5 text-sm text-[var(--text)] focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition-all"
                value={end}
                onChange={(e) => {
                  const val = e.target.value;

                  if (val > today) {
                    toast.error("End date cannot be in the future!");
                    return;
                  }

                  if (start && val < start) {
                    toast.error("End date cannot be before start date!");
                    return;
                  }

                  setEnd(val);
                }}
              />
            </div>
          </div>

          {/* Generate Button */}
          <div className="flex justify-center mt-6">
            <Button
              onClick={!loading ? createPdf : null}
              disabled={loading}
              className="px-6 py-1 text-white font-semibold bg-[var(--primary)] hover:brightness-90 focus:ring-0 focus:outline-none transition-all rounded-lg flex items-center justify-center"
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <Spinner size="sm" /> Generating...
                </div>
              ) : (
                "Generate Bill"
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* PDF Viewer Section */}
      {/* PDF Viewer Section */}
      <div className="flex-1 w-full max-w-6xl px-4 pb-6">
        {loading ? (
          <div
            className="flex flex-col justify-center items-center"
            style={{ height: windowSize[1] - 400 }}
          >
            <Loading height={windowSize[1] - 400} />
            <p className="mt-3 text-sm text-[var(--text)]">
              Please wait while we generate your bill...
            </p>
          </div>
        ) : url ? (
          <div
            style={{ height: windowSize[1] - 400 }}
            className="relative w-full mt-4 border rounded-lg overflow-hidden shadow-sm"
          >
            <iframe
              src={url}
              width="100%"
              height="100%"
              className="rounded-lg"
              style={{ border: "none" }}
              title="Bill PDF"
            />
          </div>
        ) : (
          <div
            className="flex flex-col justify-center items-center border-2 border-dashed border-[var(--hover)] rounded-xl p-10 text-center text-[var(--subtext)] mt-4"
            style={{ height: windowSize[1] - 400 }}
          >
            <p>
              No bill generated yet. Select dates and click “Generate Bill”.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
